import React from 'react';
import PropTypes from 'prop-types';
import BuildChildren from 'utils/BuildChildren';
import classes from './CardImageB.module.scss';

const CardImageB = (props) => {
  const {
    heading,
    imageURI,
    imageAltText = '',
    contentMarkup,
    buttons = [],
    imageHeight,
    imageWidth,
  } = props;

  return (
    <div className={classes.container}>
      <img
        className={classes.image}
        src={imageURI}
        alt={imageAltText}
        width={imageWidth}
        height={imageHeight}
        loading='lazy'
        aria-hidden
      />
      <div className={classes.content}>
        {heading &&
          <h3
            className={classes.title}
            dangerouslySetInnerHTML={{ __html: heading }}
          />}
        {contentMarkup &&
          <div
            className={classes.contentMarkup}
            dangerouslySetInnerHTML={{ __html: contentMarkup }}
          />}
        {buttons && buttons.length > 0 &&
          <div className={classes.buttons}>
            {buttons.map((button, i) => (
              <div className={classes.button} key={i}>
                {BuildChildren(button)}
              </div>
            ))}
          </div>}
      </div>
    </div>
  );
};

CardImageB.propTypes = {
  /**
   * Heading on the card
  */
  heading: PropTypes.string,
  /**
   * Image URL
  */
  imageURI: PropTypes.string,
  /**
   * Image alternate text that displays on hover over of image
  */
  imageAltText: PropTypes.string,
  /**
   * Content of the card
  */
  contentMarkup: PropTypes.string,
  /**
   * List of buttons
  */
  buttons: PropTypes.array,
  /**
   * Pixel height of image
  */
  imageHeight: PropTypes.number,
  /**
   * Pixel width of image
  */
  imageWidth: PropTypes.number,
};

export default CardImageB;
